<template>
  <el-dialog title="Manage Rebuttal Users" :visible.sync="showModal" width="80%" :before-close="handleClose" :destroy-on-close="true">
    <UserAdminList :rebuttalUsersOnly="true"></UserAdminList>
  </el-dialog>
</template>

<script>
  import UserAdminList from './UserAdminList'
  export default {
    name: 'RebuttalUserAdminModal',
    props: ['showModal'],
    data: function () {
      return {
      }
    },
    components: {
      UserAdminList
    },
    methods: {
      handleClose() {
        this.$emit('close')
      }
    }
  }
</script>
